import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, oklch(0.97 0.015 85) 0%, oklch(0.94 0.06 60) 40%, oklch(0.88 0.08 40) 100%)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/20" />

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-10">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-12">
            <div className="lg:w-[58%] flex flex-col gap-6">
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full text-xs font-medium text-primary-600 whitespace-nowrap">
                  <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse" />
                  实时更新 · 每日不打烊
                </span>
              </div>

              <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
                每日爆料
                <br />
                每日黑料
                <br />
                <span className="text-primary-500">实时更新</span>
              </h1>

              <p className="text-base md:text-lg text-foreground-600 max-w-lg leading-relaxed">
                汇聚今日大瓜独家速报、网红翻车实锤与明星八卦，
                免费吃瓜官网入口，吃瓜群众必备聚集地。
              </p>

              <div className="flex items-center gap-4 pt-2">
                <Link
                  to="/category/dushijubao"
                  className="px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
                >
                  立即吃瓜
                  <i className="ri-arrow-right-line ml-2" />
                </Link>
                <Link
                  to="/category/star-gossip"
                  className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap underline underline-offset-4"
                >
                  明星八卦专区 →
                </Link>
              </div>
            </div>

            <div className="lg:w-[42%] flex flex-col gap-6 pt-4 lg:pt-16">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                每日吃瓜官网专注每日爆料与每日黑料实时更新。
                作为免费吃瓜官网入口，我们365天不间断更新，
                从娱乐圈猛料到网红翻车现场，第一时间为你呈现最热乎的大瓜。
              </p>
              <div className="flex items-center gap-3 text-foreground-500 text-sm">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-primary-500" />
                  今日更新 28 条
                </span>
                <span className="text-foreground-300">|</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line text-primary-500" />
                  总浏览量 5200万+
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 px-4 md:px-6 pb-6 z-10">
        <div className="max-w-[1280px] mx-auto">
          <div className="w-full h-[180px] md:h-[240px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20collage%20with%20celebrities%20and%20paparazzi%20style%20photography%2C%20warm%20dramatic%20lighting%2C%20low%20saturation%2C%20editorial%20magazine%20layout%2C%20dark%20moody%20atmosphere%2C%20cinematic%20composition%2C%20mysterious%20vibe&width=1600&height=480&seq=chigua-hero-bottom&orientation=landscape"
              alt="每日吃瓜 - 娱乐圈最新爆料与独家速报"
              title="每日吃瓜 - 娱乐圈最新爆料与独家速报"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}